
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.384 12 12s-5.384 12-12 12S4 22.616 4 16 9.384 4 16 4zm0 2C10.465 6 6 10.465 6 16s4.465 10 10 10 10-4.465 10-10S21.535 6 16 6zm0 1a1 1 0 110 2 1 1 0 010-2zm-5.656 2.344a1 1 0 110 2 1 1 0 010-2zm10.594.312l1.438 1.406-4.438 4.438a2 2 0 11-1.437-1.437zM8 15a1 1 0 110 2 1 1 0 010-2zm16 0a1 1 0 110 2 1 1 0 010-2zm-13.656 5.656a1 1 0 110 2 1 1 0 010-2zm11.312 0a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    